import { render, staticRenderFns } from "./stockout_edit.vue?vue&type=template&id=28c239c8&scoped=true"
import script from "./stockout_edit.vue?vue&type=script&lang=js"
export * from "./stockout_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c239c8",
  null
  
)

export default component.exports